import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { MapPin, Calendar, Clock, PhoneCall, ArrowRightCircle, Globe, Building } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';
import AppointmentModal from './AppointmentModal';


const LocationSection: React.FC = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);
    const navigate = useNavigate();

    return (
        <section className="py-16 md:py-24 bg-gradient-to-br from-red-50/50 to-white">
            <div className="container mx-auto px-4">

                <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-start">
                    {/* CTA Column */}
                    <motion.div
                        initial={{ opacity: 0, x: 20 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.6, delay: 0.3 }}
                        viewport={{ once: true }}
                        className="space-y-8"
                    >
                        <div className="space-y-4">
                            <h2 className="text-3xl md:text-4xl font-bold text-teal-700">
                                Begin Your Journey Today
                            </h2>
                            <p className="text-gray-600 text-lg">
                                Take the first step towards mental wellness. Choose between our welcoming space in West Patel Nagar or convenient online sessions from the comfort of your home.
                            </p>
                        </div>

                        <div className="grid gap-4">
                            
                             <div className="flex items-center gap-4 p-4 bg-white rounded-xl shadow-sm">
                                <Building className="text-golden-yellow" size={24} />
                                <div>
                                    <h3 className="font-semibold text-orange-400">In-Person Sessions</h3>
                                    <p className="text-gray-600">Visit our therapeutic sanctuary in West Patel Nagar</p>
                                </div>
                            </div>

                            <div className="flex items-center gap-4 p-4 bg-white rounded-xl shadow-sm">
                                <Globe className="text-golden-yellow" size={24} />
                                <div>
                                    <h3 className="font-semibold text-orange-400">Online Sessions</h3>
                                    <p className="text-gray-600">Secure video sessions from anywhere in the world</p>
                                </div>
                            </div>

                            <div className="flex items-center gap-4 p-4 bg-white rounded-xl shadow-sm">
                                <Clock className="text-golden-yellow" size={24} />
                                <div>
                                    <h3 className="font-semibold text-orange-400">Flexible Timings</h3>
                                    <p className="text-gray-600">Monday to Sunday, 10 AM - 9 PM</p>
                                </div>
                            </div>

                            <div className="flex items-center gap-4 p-4 bg-white rounded-xl shadow-sm">
                                <Calendar className="text-golden-yellow" size={24} />
                                <div>
                                    <h3 className="font-semibold text-orange-400">Easy Scheduling</h3>
                                    <p className="text-gray-600">Book your preferred session type at your convenience</p>
                                </div>
                            </div>
                        </div>

                        <div className="flex flex-col sm:flex-row gap-4">
                            <Link
                                to="/book-appointment"
                                className="inline-flex items-center justify-center px-6 py-3 bg-orange-400 text-white rounded-xl transition-colors text-md md:text-lg font-medium"
                               
                            >
                                Book Appointment
                                <ArrowRightCircle className="ml-2" size={20} />
                            </Link>
                            <a
                                href="tel:+918591049845"
                                className="inline-flex items-center justify-center px-6 py-3 border-2 border-golden-teal-600 text-teal-700 rounded-xl transition-colors text-md md:text-lg font-medium"
                            >
                                Call Us
                                <PhoneCall className="ml-2" size={20} />
                            </a>
                        </div>
                    </motion.div>

                    {/* Map Column */}
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6 }}
                        viewport={{ once: true }}
                        className="w-full h-[400px] rounded-2xl overflow-hidden shadow-lg relative"
                    >
                        <iframe
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3501.379812621804!2d77.16425994994924!3d28.648344161287906!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d02ec6a90cbcd%3A0x486cd6e6f569700b!2s4%2C%20W%20Patel%20Nagar%20Rd%2C%20Block%207%2C%20West%20Patel%20Nagar%2C%20Patel%20Nagar%2C%20New%20Delhi%2C%20Delhi%2C%20110008!5e0!3m2!1sen!2sin!4v1735827897291!5m2!1sen!2sin"
                            width="100%"
                            height="100%"
                            style={{ border: 0 }}
                            allowFullScreen
                            loading="lazy"
                            title="Greh Pravesh Location"
                            referrerPolicy="no-referrer-when-downgrade"
                        />
                        <div className="absolute bottom-4 left-4 right-4 bg-white/90 backdrop-blur-sm p-4 rounded-xl shadow-lg">
                            <div className="flex items-center gap-2 text-charcoal">
                                <MapPin className="text-golden" size={20} />
                                <p className="text-sm">4/20, West Patel Nagar, New Delhi-110008</p>
                            </div>
                        </div>
                    </motion.div>

                </div>
                <AppointmentModal isOpen={isModalOpen} onClose={closeModal} />
 
            </div>

        </section>
    );
};

export default LocationSection;